import phoneMask from 'helpers/phone';
import initialState from 'helpers/signUp/initialState';
import { DEALERSHIP_AGE, JOB_FUNCTION } from 'partials/sign_up/data';
import { getBusinessTypeOptionFromRails } from 'partials/sign_up/data/businessTypes';

const getStep0Values = (actionValues) => {
	const businessType = getBusinessTypeOptionFromRails(actionValues.businessType);

	const values = {
		...actionValues,
		mobilePhone: phoneMask(actionValues.mobilePhone),
		hasUSLicense: actionValues.hasUSLicense ? 'yes' : 'no',
		businessType: businessType?.value || '',
		recaptcha: '',
	};
	const documents = actionValues.marketplaceDocuments;
	if (documents) {
		documents.forEach((document) => {
			values[document.type] = { value: true, id: document.id };
		});
	}

	return values;
};

const getStep1Values = (actionValues) => {
	const railsDealershipAge = actionValues.dealershipAge;
	const dealershipAge = DEALERSHIP_AGE.find((age) => age.railsValue == railsDealershipAge);

	const railsJobFunctionValue = actionValues.jobFunction;
	const jobFunction = JOB_FUNCTION.find((job) => job.railsValue === railsJobFunctionValue);
	return {
		...actionValues,
		dealershipAge: dealershipAge?.value || '',
		jobFunction: jobFunction?.value || 0,
		dealershipPhone: phoneMask(actionValues.dealershipPhone),
	};
};

const getStep2Values = (actionValues) => {
	const dealerLicenseFile = getLicenseFile(
		actionValues.dealerLicenseFile,
		actionValues.dealerLicenseContentType,
		actionValues.dealerLicenseModifiedAt,
	);

	const driverLicenseFile = getLicenseFile(
		actionValues.driverLicenseFile,
		actionValues.driverLicenseContentType,
		actionValues.driverLicenseModifiedAt,
	);

	return {
		dealerLicenseFile,
		dealerLicenseUrl: actionValues.dealerLicenseUrl,
		driverLicenseFile,
		driverLicenseUrl: actionValues.driverLicenseUrl,
		taxID: actionValues.taxID,
	};
};

const getStep3Values = (actionValues) => ({
	password: '',
	passwordConfirmation: '',
	paymentMethods: actionValues?.paymentMethods,
});

const getPartialSignUpValues = (actionValues) => [
	getStep0Values(actionValues[0]),
	getStep1Values(actionValues[1]),
	getStep2Values(actionValues[2]),
	getStep3Values(actionValues[3]),
];

const getAuctionAccessDealershipType = (stepValues) => {
	const dealerships = stepValues[0]?.auctionAccess?.dealerships;
	return dealerships?.length === 1 ? dealerships[0]?.dealershipType : undefined;
};

const getLicenseFile = (fileName, contentType, lastModified) => {
	if (fileName?.length && contentType?.length && lastModified?.length) {
		const fileOptions = { type: contentType, lastModified: new Date(lastModified) };
		const file = new File([''], fileName, fileOptions);
		const fileList = new DataTransfer();
		fileList.items.add(file);
		return fileList.files;
	}
	return null;
};

const reducer = function reducer(state, action) {
	// prettier-ignore
	switch (action.type) {
	case 'onSaveStepSuccess': {
		const values = state.values;
		values[action.step] = action.values;

		return {
			...state,
			step: action.step + 1,
			resumeStep: -1,
			token: action.token || state.token,
			values,
		};
	}
	case 'onBack':
		return { ...state, step: state.step - 1, resumeStep: -1, backButtonClicked: true, error: '' };
	case 'onReturnToAuctionAccessLookup':
		return { ...state, step: 0, resumeStep: -1, backButtonClicked: false, error: '' };
	case 'onRestoreStandardSignup': {
		const standardSignupState = initialState();
		return {
			...standardSignupState,
			loadedPartialData: true,
			values: [{ ...standardSignupState.values[0], ...action.values }, ...standardSignupState.values.slice(1)],
		};
	}
	case 'onSetAuctionAccessReviewValues': {
		const values = [...state.values];
		values[2] = { ...values[2], ...action.values };

		return {
			...state,
			auctionAccessDealershipType: action.dealershipType,
			token: action.token || state.token,
			values,
		};
	}
	case 'onGetPartialData': {
		return {
			...state,
			auctionAccessDealershipType: getAuctionAccessDealershipType(action.values),
			step: action.startStep ?? action.step + 1,
			values: getPartialSignUpValues(action.values),
			token: action.token || state.token,
			loadedPartialData: true,
			resumeStep: action.resumeStep
		};
	}
	case 'onHydrateAuctionAccessSignUp':
		return {
			...state,
			step: 0,
			values: getPartialSignUpValues(action.values),
			token: action.token,
			loadedPartialData: true,
			resumeStep: -1,
			backButtonClicked: false,
			auctionAccessDealershipType: undefined,
			error: '',
		};
	case 'onGetPartialDataError':
		return { ...state, error: action.error, loadedPartialData: true };
	case 'onSetLoadedPartialData':
		return { ...state, loadedPartialData: true };
	case 'onSetAuctionAccessPaymentMethods': {
		const values = [...state.values];
		values[3] = { ...values[3], paymentMethods: action.paymentMethods };

		return { ...state, values };
	}
	case 'onSetAuctionAccessPaymentMethodSelection': {
		// this is used to persist the selection in case that user navigates back and forth between steps 3 and 4
		const values = [...state.values];
		const paymentMethods = values[3]?.paymentMethods || {};
		values[3] = {
			...values[3],
			paymentMethods: {
				...paymentMethods,
				selection: { ...paymentMethods.selection, ...action.selection },
			},
		};

		return { ...state, values };
	}
	case 'onSetError':
		return { ...state, error: action.error };
	}
};

export default reducer;
